var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61645 16.5979V20.3474H7.88488L6.31074 22H2V18.1441L3.61645 16.5979Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23291 13.6351V18.6952H11.254C11.539 18.6952 11.8124 18.5798 12.0143 18.3743L18.5043 11.7696L12.4762 5.60714L12.4717 5.6026L5.53926 12.8657C5.34286 13.0715 5.23291 13.3476 5.23291 13.6351Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6006 4.42004C13.6069 4.4261 13.6131 4.43229 13.6193 4.43861L19.6501 10.6037L21.3653 8.85822C22.2102 7.99832 22.2118 6.6005 21.3687 5.73864L18.3428 2.64536C17.4938 1.7774 16.1146 1.78606 15.2761 2.6646L13.6006 4.42004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutter);
export default __webpack_public_path__ + "static/media/cutter.a7c6748d4a53b53f75acb94b56232a86.svg";
export { ForwardRef as ReactComponent };